module.exports = __webpack_public_path__ + "img/featuredIcon.774cb44b.png";